import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "arrow-down",
  "use": "arrow-down-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" stroke-width=\"2\" class=\"feather feather-arrow-down\" viewBox=\"0 0 24 24\" id=\"arrow-down\"><path d=\"M12 5v14M19 12l-7 7-7-7\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol